import React from "react";
import GetByTransferNoResultsNotification
    from "@SearchResults/features/banners/features/getByTransferBanner/components/GetByTransferNoResultsNotification";
import {TransfersDataType} from "@SearchResults/features/banners/features/getByTransferBanner/types/TransfersData.type";
import ParamsType from "@/pages/searchResults/types/params/Params.type";

interface NoResultsWithGbtPromoProps {
    transfersData: TransfersDataType,
}

function NoResultsWithGbtPromo(props: NoResultsWithGbtPromoProps) {
    const {
        transfersData,
    } = props

    const {
        vehicles,
    } = transfersData || {}

    return (
        <GetByTransferNoResultsNotification
            vehicles={vehicles}
        />
    )
}

export default NoResultsWithGbtPromo